import { render, staticRenderFns } from "./auditRecordDialog.vue?vue&type=template&id=6a06e888&scoped=true"
import script from "./auditRecordDialog.vue?vue&type=script&lang=js"
export * from "./auditRecordDialog.vue?vue&type=script&lang=js"
import style0 from "./auditRecordDialog.vue?vue&type=style&index=0&id=6a06e888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a06e888",
  null
  
)

export default component.exports